import { QuestionModel } from 'core/models/elements/questions/question.abstract.model';

/**
 * @class Defines a paper question: a PDF to print, answered on paper.
 */
export class PaperQuestionModel extends QuestionModel {
  /**
   * @constructor Creates an instance of a paper question built from an original data from the API.
   * @param {bo} bo is the basic object come from API.
   */
  constructor(bo) {
    super(bo);
    this.printFileUrl = bo.print_file_url;
  }
}
